import React, { useEffect, useRef } from 'react';
import styles from './DropdownSmsSelect.module.css';
import { ReactComponent as IconCall } from 'static/assets/icon-call.svg';
import { ReactComponent as IconSms } from 'static/assets/icon-sms.svg';
const optionsDefault = [
  {
    icon: IconCall,
    label: 'Через звонок',
    value: 'FLASH_CALL',
  },
  {
    icon: IconSms,
    label: 'Через СМС',
    value: 'SMS',
  },
];

export const DropdownSmsSelect = ({ options = optionsDefault, onSelect, open, onClose }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose && onClose();
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, onClose]);

  const handleSelect = (value) => {
    onSelect && onSelect(value);
  };

  if (!open) return null;

  return (
    <div className={styles.dropdownBox} ref={dropdownRef}>
      {options.map((opt) => {
        const Icon = opt.icon;
        return (
          <button
            key={opt.value}
            className={styles.dropdownOption}
            onClick={() => handleSelect(opt.value)}
            type="button"
          >
            <span className={styles.icon}>
              <Icon />
            </span>
            <span className={styles.label}>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};
